export default __webpack_public_path__ + "static/media/updateEmail.6e5da6aa.svg";